export const EXCMDEVICEBRAND_SHOW_RESET = 'EXCMDEVICEBRAND_SHOW_RESET'
export const EXCMDEVICEBRAND_SHOW_SET_ERROR = 'EXCMDEVICEBRAND_SHOW_SET_ERROR'
export const EXCMDEVICEBRAND_SHOW_SET_RETRIEVED = 'EXCMDEVICEBRAND_SHOW_SET_RETRIEVED'
export const EXCMDEVICEBRAND_SHOW_TOGGLE_LOADING = 'EXCMDEVICEBRAND_SHOW_TOGGLE_LOADING'
